var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgId = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m489.715 167.004v284.952c0 26.534-21.51 48.044-48.044 48.044h-296.28c-26.534 0-48.044-21.51-48.044-48.044v-391.912c0-26.534 21.51-48.044 48.044-48.044h198.441z",
    fill: "#c96788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.714 167.004h-113.853c-17.689 0-32.029-14.34-32.029-32.029v-122.974z",
    fill: "#7f1d32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.888 427.607h-371.403c-5.081 0-9.2-4.119-9.2-9.2v-168.324c0-5.081 4.119-9.2 9.2-9.2h371.403c5.081 0 9.2 4.119 9.2 9.2v168.324c0 5.081-4.119 9.2-9.2 9.2z",
    fill: "#7f1d32"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m170.36 382.919c-2.064 0-3.91-.438-5.599-1.314-1.72-.845-2.565-2.19-2.565-4.066v-101.78c0-1.814.845-3.159 2.565-3.972 1.689-.845 3.534-1.22 5.599-1.22 2.033 0 3.91.375 5.599 1.22 1.689.813 2.534 2.158 2.534 3.972v101.781c0 1.877-.845 3.222-2.534 4.066-1.689.875-3.565 1.313-5.599 1.313z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.018 382.919c-2.127 0-3.879-.5-5.224-1.501-1.314-1.063-2.002-2.252-2.002-3.691v-101.968c0-1.408.688-2.627 2.002-3.691 1.345-1.001 3.097-1.501 5.224-1.501h27.212c6.475 0 12.324 1.126 17.61 3.378s9.446 5.88 12.449 10.885c3.034 5.036 4.535 11.698 4.535 20.018v43.79c0 8.32-1.501 14.982-4.535 20.018-3.003 5.005-7.163 8.633-12.449 10.885s-11.135 3.378-17.61 3.378zm9.071-14.451h18.142c5.755 0 10.228-1.595 13.45-4.817 3.253-3.253 4.848-8.258 4.848-15.014v-43.79c0-6.756-1.595-11.761-4.848-15.014-3.222-3.222-7.695-4.817-13.45-4.817h-18.142z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgId);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/id.21a79c5434b8523c3dc0796e11b96999.svg";